/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React from "react";
import { TabPanel } from "@carbon/react";

export default ({ children }) => {
  return <TabPanel>{children}</TabPanel>;
};
